export default {
  data() {
    return {
      universitiesList: [],
      terminehList: [],
      creatingFormBody: {
        missionId: null,
        emergencyMedicalCenterId: null,
      },
      closingFormBody: {
        missionId: null,
        closeNote: null,
      },
    };
  },
  computed: {
    transformedTerminehList: function () {
      return [...this.terminehList]?.map(
        ({ mission, creationDate, currentState, missionCode, emergencyMedicalCenter, user }) => ({
          id: mission?.id,
          creationDate,
          currentState: currentState || '-',
          missionCode: missionCode || '-',
          address: mission?.address || '-',
          callerId: mission?.callerId,
          otherPhoneNumber: mission?.otherPhoneNumber,
          diagnosisTitle: mission?.diagnosisTitle || '-',
          emergencyMedicalCenterTitle: emergencyMedicalCenter?.title || '-',
          fullName: `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || '-',
        }),
      );
    },
  },
  methods: {
    getAllUniversities() {
      this.load.val = true;
      this.$store
        .dispatch('getAllUniversitiesListDispatch')
        .then(() => {
          if (this.$store.state.terminehModule.successFlag)
            this.universitiesList = this.$store.state.terminehModule.allUniversitiesList;
          else {
            if (this.$store.state.terminehModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllUniversities();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.terminehModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllUniversities();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .catch(() => {
          this.$toast.error('خطا در دریافت لیست دانشگاه ها');
        })
        .finally(() => (this.load.val = false));
    },
    getAllActiveTerminehList() {
      this.load.val = true;
      this.$store
        .dispatch('getAllActiveTerminehListDispatch')
        .then(() => {
          if (this.$store.state.terminehModule.successFlag)
            this.terminehList = this.$store.state.terminehModule.allActiveTerminehList;
          else {
            if (this.$store.state.terminehModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllActiveTerminehList();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.terminehModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllActiveTerminehList();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .catch(() => {
          this.$toast.error('خطا در دریافت لیست دانشگاه ها');
        })
        .finally(() => (this.load.val = false));
    },
    showError: function () {
      const errorText = this.$store.state.terminehModule.error;
      this.showErrorAlert(errorText);
    },
    createNewTermineh: function (onSuccess) {
      this.load.val = true;
      this.$store
        .dispatch('createNewTerminehDispatch', this.creatingFormBody)
        .then(() => {
          if (this.$store.state.terminehModule.successFlag) {
            this.showSuccessAlert('اطلاعات با موفقیت ثبت شد.');
            onSuccess();
          } else {
            if (this.$store.state.terminehModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.createNewTermineh(onSuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.terminehModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.createNewTermineh(onSuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    closeTermineh: function (onSuccess) {
      this.load.val = true;
      this.$store
        .dispatch('closeTerminehDispatch', this.closingFormBody)
        .then(() => {
          if (this.$store.state.terminehModule.successFlag) {
            this.showSuccessAlert('ترمینه موردنظر حذف شد');
            onSuccess();
          } else {
            if (this.$store.state.terminehModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.closeTermineh(onSuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.terminehModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.closeTermineh(onSuccess);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
  },
};
